module.exports = __webpack_public_path__ + "static/digital-titan-mag-video-thumb-420ca2fbd68b58dd47b3bc818ca2b68c.jpg";